import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rgmjpifqmnglgdcwrkpc.supabase.co';
const supabaseKey = 'sb_publishable_3tO_FspP7eacQGDSuuZlog_OfXfDRFC';

export const supabase = createClient(supabaseUrl, supabaseKey);